export const RETURN_TO_LEARN_ROUTE = {
  name: 'returntolearn',
  route(): string[] {
    return ['/', this.name];
  },
  DEFAULT: '',
  ANALYSIS: {
    name: 'analysis',
    route(): string[] {
      return [...RETURN_TO_LEARN_ROUTE.route(), this.name];
    }
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...RETURN_TO_LEARN_ROUTE.route(), this.name];
    }
  },
  SUPPORT: {
    name: 'supportingmathteaching',
    route(): string[] {
      return [...RETURN_TO_LEARN_ROUTE.route(), this.name];
    }
  },
  THOUGHT_LEADERSHIP: {
    name: 'thoughtleadership',
    route(): string[] {
      return [...RETURN_TO_LEARN_ROUTE.route(), this.name];
    }
  }
};
